import { render, staticRenderFns } from "./CustomerRegister.vue?vue&type=template&id=5b25dd26&scoped=true&"
import script from "./CustomerRegister.vue?vue&type=script&lang=js&"
export * from "./CustomerRegister.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b25dd26",
  null
  
)

export default component.exports